import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../../globals';
import { AuthenticationResponseModel } from '../model/authentication-response.model';
import { InterceptorSkipHeader } from '../helpers/authinterceptor';
import { RefreshTokenService } from '../services/refresh-token.service';
import { tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class PatientLoginService {

  constructor(private http: HttpClient, private globals: Globals,
    private refreshTokenService: RefreshTokenService,) { }

  public authenticatePatient(username: any, password: any, token: any): any {

    const params = new HttpParams({
      fromObject: {
        grant_type: 'password',
        username: username,
        password: password,
        token: token,
        callingapp: 'TDOX',
        loginType: 'patient',
      }
    });

    return this.http.post<AuthenticationResponseModel>('/api/jwtauthentication/login', params,    
    {headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }).set(InterceptorSkipHeader, ''), withCredentials: true})
      .pipe(
        tap((_) => {
          if (_.isSuccess) {
            this.globals.TDOCID = _.tdoCId;
            this.setToken(_.token);
            this.refreshTokenService.scheduleNextRefreshToken();
          }
        })
      );
  }

  requestAuthToken(username: any): any{

    const params = new HttpParams({
      fromObject: {
        username: username,
        baseUrl: location.origin,
        loginType: 'patient',
      }
    });

    return this.http.post<AuthenticationResponseModel>('/api/jwtauthentication/patienttoken', params,    
    {headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }).set(InterceptorSkipHeader, ''), withCredentials: true})      ;
  }
  setToken(token: string) {
    localStorage.setItem('TDOauthToken', token);
  }
  
}
